// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"no","cardInnerHeading":"np","editButton":"nq","formClass":"nr","inputClass":"ns","pw":"nt","enterCurrentPw":"nu","cancelButton":"nv","submitButton":"nw"};